import { Injectable, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class NotificationService {

    constructor(
        private injector: Injector,
    ) { }

    public notify(type, title, message, from, align) {

        const toastr = this.injector.get(ToastrService);

        switch (type) {

            case 'info':
                toastr.info('<span class="now-ui-icons travel_info"></span> ' + message, title, {
                    onActivateTick: true,
                    timeOut: 8000,
                    closeButton: true,
                    enableHtml: true,
                    toastClass: 'alert alert-info alert-with-icon',
                    positionClass: 'toast-' + from + '-' + align
                });
                break;
            case 'success':
                toastr.success('<span class="now-ui-icons ui-1_check"></span> ' + message, title, {
                    onActivateTick: true,
                    timeOut: 8000,
                    closeButton: true,
                    enableHtml: true,
                    toastClass: 'alert alert-success alert-with-icon',
                    positionClass: 'toast-' + from + '-' + align
                });
                break;
            case 'warning':
                toastr.warning('<span class="now-ui-icons objects_support-17"></span> ' + message, title, {
                    onActivateTick: true,
                    timeOut: 8000,
                    closeButton: true,
                    enableHtml: true,
                    toastClass: 'alert alert-warning alert-with-icon',
                    positionClass: 'toast-' + from + '-' + align
                });
                break;
            case 'danger':
                toastr.error('<span class="now-ui-icons media-2_sound-wave"></span> ' + message, title, {
                    onActivateTick: true,
                    timeOut: 8000,
                    enableHtml: true,
                    closeButton: true,
                    toastClass: 'alert alert-danger alert-with-icon',
                    positionClass: 'toast-' + from + '-' + align
                });
                break;
            case 'primary':
                toastr.show('<span class="now-ui-icons ui-1_bell-53"></span> ' + message, title, {
                    onActivateTick: true,
                    timeOut: 8000,
                    closeButton: true,
                    enableHtml: true,
                    toastClass: 'alert alert-primary alert-with-icon',
                    positionClass: 'toast-' + from + '-' + align
                });
                break;
            default:
                break;
        }

    }



}



// WEBPACK FOOTER //
// ./src/app/_services/notification.service.ts